import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Hockey = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1305_4232)">
        <path
          opacity="0.972"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.32031 -0.0234375C1.78908 -0.0234375 1.2578 -0.0234375 0.726562 -0.0234375C0.718734 0.726727 0.726562 1.47673 0.75 2.22656C2.34375 5.1953 3.9375 8.16408 5.53125 11.1328C6.25566 10.7123 6.96656 10.2748 7.66406 9.82031C5.88225 6.5378 4.101 3.25655 2.32031 -0.0234375Z"
          fill={color}
        />
        <path
          opacity="0.987"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2422 0.726561C13.6275 0.543069 11.4009 1.3712 9.5625 3.21094C9.37275 3.41623 9.20086 3.63498 9.04688 3.86719C9.01561 4.97658 9.01561 6.08592 9.04688 7.19531C10.4062 9.11719 11.7656 11.0391 13.125 12.9609C13.1406 10.6328 13.1563 8.3047 13.1719 5.97656C13.1953 5.76562 13.3125 5.64844 13.5234 5.625C16.5859 5.60939 19.6484 5.59373 22.7109 5.57812C21.433 2.79063 19.2767 1.17344 16.2422 0.726561ZM13.4766 3.35156C13.2619 3.33344 13.0587 3.3725 12.8672 3.46875C12.6819 3.8861 12.8225 4.09704 13.2891 4.10156C13.7556 4.09704 13.8962 3.8861 13.7109 3.46875C13.6259 3.43327 13.5478 3.39421 13.4766 3.35156ZM12.0234 3.35156C11.8088 3.33344 11.6056 3.3725 11.4141 3.46875C11.2288 3.8861 11.3694 4.09704 11.8359 4.10156C12.3025 4.09704 12.4431 3.8861 12.2578 3.46875C12.1727 3.43327 12.0946 3.39421 12.0234 3.35156Z"
          fill={color}
        />
        <path
          opacity="0.987"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.9922 6.35156C22.0078 6.35156 21.0234 6.35156 20.0391 6.35156C20.2293 6.97711 20.4246 7.60214 20.625 8.22656C20.6484 8.60123 20.6562 8.97623 20.6484 9.35156C21.5234 9.35156 22.3984 9.35156 23.2734 9.35156C23.3409 8.33498 23.2472 7.335 22.9922 6.35156Z"
          fill={color}
        />
        <path
          opacity="0.986"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2891 6.35156C18.4141 6.35156 17.5391 6.35156 16.6641 6.35156C16.8543 6.97711 17.0497 7.60214 17.25 8.22656C17.2734 8.60123 17.2812 8.97623 17.2734 9.35156C18.1485 9.35156 19.0234 9.35156 19.8984 9.35156C19.9062 8.94502 19.8984 8.53875 19.875 8.13281C19.6747 7.5397 19.4794 6.94594 19.2891 6.35156Z"
          fill={color}
        />
        <path
          opacity="0.979"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9141 6.35156C15.2422 6.35156 14.5703 6.35156 13.8985 6.35156C13.8828 7.02417 13.8985 7.69603 13.9453 8.36719C14.7995 8.66752 15.6588 8.94877 16.5235 9.21094C16.5312 8.85122 16.5235 8.49183 16.5 8.13281C16.2997 7.5397 16.1044 6.94594 15.9141 6.35156Z"
          fill={color}
        />
        <path
          opacity="0.975"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0391 9.11719C13.9922 9.11719 13.9453 9.11719 13.8985 9.11719C13.8828 9.86784 13.8985 10.6178 13.9453 11.3672C14.7995 11.6675 15.6588 11.9488 16.5235 12.2109C16.5391 11.4603 16.5234 10.7103 16.4766 9.96094C15.656 9.68747 14.8435 9.40622 14.0391 9.11719Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2734 10.1016C22.3984 10.1016 21.5234 10.1016 20.6484 10.1016C20.6484 10.8516 20.6484 11.6016 20.6484 12.3516C21.5234 12.3516 22.3984 12.3516 23.2734 12.3516C23.2734 11.6016 23.2734 10.8516 23.2734 10.1016Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8984 10.1016C19.0234 10.1016 18.1485 10.1016 17.2734 10.1016C17.2734 10.8516 17.2734 11.6016 17.2734 12.3516C18.1485 12.3516 19.0234 12.3516 19.8984 12.3516C19.8984 11.6016 19.8984 10.8516 19.8984 10.1016Z"
          fill={color}
        />
        <path
          opacity="0.966"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.03906 10.4766C7.2983 10.8704 6.57952 11.3 5.88281 11.7656C6.65405 13.2849 7.46653 14.7772 8.32031 16.2422C9.04045 15.8355 9.74358 15.4058 10.4297 14.9531C9.62602 13.4629 8.82914 11.9707 8.03906 10.4766Z"
          fill={color}
        />
        <path
          opacity="0.973"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.039 12.1172C13.9922 12.1172 13.9453 12.1172 13.8984 12.1172C13.8906 12.8048 13.8984 13.4924 13.9219 14.1797C14.1425 14.5664 14.3691 14.9492 14.6015 15.3281C15.0075 15.3516 15.4137 15.3593 15.8203 15.3516C16.0194 14.7342 16.2459 14.1248 16.5 13.5234C16.5387 13.334 16.5309 13.1465 16.4765 12.9609C15.6559 12.6875 14.8435 12.4062 14.039 12.1172Z"
          fill={color}
        />
        <path
          opacity="0.979"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2734 13.1016C22.3984 13.1016 21.5234 13.1016 20.6484 13.1016C20.6558 13.2929 20.6323 13.4804 20.5781 13.6641C20.3513 14.2195 20.1248 14.7743 19.8984 15.3281C20.6753 15.3668 21.4488 15.359 22.2187 15.3047C22.5507 14.7188 22.8944 14.1407 23.25 13.5703C23.2733 13.4148 23.2812 13.2586 23.2734 13.1016Z"
          fill={color}
        />
        <path
          opacity="0.982"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8984 13.1016C19.0234 13.1016 18.1484 13.1016 17.2734 13.1016C17.2807 13.2929 17.2573 13.4804 17.2031 13.6641C16.9763 14.2195 16.7498 14.7743 16.5234 15.3281C17.4139 15.3516 18.3045 15.3594 19.1953 15.3516C19.3944 14.7342 19.6209 14.1248 19.875 13.5234C19.8983 13.3837 19.9061 13.243 19.8984 13.1016Z"
          fill={color}
        />
        <path
          opacity="0.983"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8047 15.5859C10.0595 15.9971 9.34078 16.4424 8.64844 16.9219C9.6105 18.7758 10.6027 20.6117 11.625 22.4297C11.9704 22.8252 12.4001 23.083 12.9141 23.2031C14.2421 23.2266 15.5702 23.2344 16.8984 23.2266C16.4113 21.4917 15.9191 19.7573 15.4219 18.0234C14.6038 17.9938 13.7835 17.9548 12.9609 17.9062C12.3586 17.7726 11.882 17.4523 11.5312 16.9453C11.2885 16.4909 11.0463 16.0378 10.8047 15.5859Z"
          fill={color}
        />
        <path
          opacity="0.98"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5078 17.9766C19.6635 17.9609 18.8198 17.9766 17.9766 18.0234C18.4766 19.7422 18.9766 21.4609 19.4766 23.1797C20.7079 23.45 21.6532 23.0594 22.3125 22.0078C22.5117 21.5268 22.5742 21.0269 22.5 20.5078C22.3866 19.8386 22.1366 19.2292 21.75 18.6797C21.3987 18.3284 20.9847 18.094 20.5078 17.9766Z"
          fill={color}
        />
        <path
          opacity="0.972"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.10155 18.3516C3.21163 18.2612 2.35227 18.3784 1.52343 18.7031C1.23922 18.8311 1.01263 19.0264 0.843738 19.2891C0.674144 19.7327 0.775676 20.0999 1.14843 20.3906C2.06043 20.9256 3.0448 21.1131 4.10155 20.9531C4.66382 20.8856 5.17944 20.6981 5.64843 20.3906C6.14844 19.9063 6.14844 19.4219 5.64843 18.9375C5.17007 18.635 4.65444 18.4396 4.10155 18.3516Z"
          fill={color}
        />
        <path
          opacity="0.963"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.02345 20.9766C4.58936 21.8059 3.08936 21.9387 1.52345 21.375C1.27 21.2601 1.02779 21.1272 0.796888 20.9766C0.508701 22.0961 0.922794 22.7914 2.03908 23.0625C2.81359 23.2415 3.59486 23.2727 4.38283 23.1562C4.95404 23.0654 5.44623 22.8232 5.85939 22.4297C5.90626 22.3515 5.95314 22.2735 6.00001 22.1953C6.02345 21.7894 6.03123 21.3831 6.02345 20.9766Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1305_4232">
          <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default Hockey;
